export default "<svg viewBox=\"0 0 97 70\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 0h96.64v69.94H0V0Z\" fill=\"#fff\"/></svg>";